export interface Country {
    code: string;
    name: string;
    flag: string;
}

export const countries: Country[] = [
    { code: 'AF', name: 'Afganistán', flag: '🇦🇫' },
    { code: 'AL', name: 'Albania', flag: '🇦🇱' },
    { code: 'DE', name: 'Alemania', flag: '🇩🇪' },
    { code: 'AD', name: 'Andorra', flag: '🇦🇩' },
    { code: 'AO', name: 'Angola', flag: '🇦🇴' },
    { code: 'AI', name: 'Anguila', flag: '🇦🇮' },
    { code: 'AQ', name: 'Antártida', flag: '🇦🇶' },
    { code: 'AG', name: 'Antigua y Barbuda', flag: '🇦🇬' },
    { code: 'SA', name: 'Arabia Saudita', flag: '🇸🇦' },
    { code: 'DZ', name: 'Argelia', flag: '🇩🇿' },
    { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: 'AM', name: 'Armenia', flag: '🇦🇲' },
    { code: 'AW', name: 'Aruba', flag: '🇦🇼' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: 'AZ', name: 'Azerbaiyán', flag: '🇦🇿' },
    { code: 'BS', name: 'Bahamas', flag: '🇧🇸' },
    { code: 'BD', name: 'Bangladés', flag: '🇧🇩' },
    { code: 'BB', name: 'Barbados', flag: '🇧🇧' },
    { code: 'BH', name: 'Baréin', flag: '🇧🇭' },
    { code: 'BE', name: 'Bélgica', flag: '🇧🇪' },
    { code: 'BZ', name: 'Belice', flag: '🇧🇿' },
    { code: 'BJ', name: 'Benín', flag: '🇧🇯' },
    { code: 'BM', name: 'Bermudas', flag: '🇧🇲' },
    { code: 'BY', name: 'Bielorrusia', flag: '🇧🇾' },
    { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
    { code: 'BA', name: 'Bosnia y Herzegovina', flag: '🇧🇦' },
    { code: 'BW', name: 'Botsuana', flag: '🇧🇼' },
    { code: 'BR', name: 'Brasil', flag: '🇧🇷' },
    { code: 'BN', name: 'Brunéi', flag: '🇧🇳' },
    { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
    { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
    { code: 'BI', name: 'Burundi', flag: '🇧🇮' },
    { code: 'BT', name: 'Bután', flag: '🇧🇹' },
    { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻' },
    { code: 'KH', name: 'Camboya', flag: '🇰🇭' },
    { code: 'CM', name: 'Camerún', flag: '🇨🇲' },
    { code: 'CA', name: 'Canadá', flag: '🇨🇦' },
    { code: 'TD', name: 'Chad', flag: '🇹🇩' },
    { code: 'CL', name: 'Chile', flag: '🇨🇱' },
    { code: 'CN', name: 'China', flag: '🇨🇳' },
    { code: 'CY', name: 'Chipre', flag: '🇨🇾' },
    { code: 'VA', name: 'Ciudad del Vaticano', flag: '🇻🇦' },
    { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
    { code: 'KM', name: 'Comoras', flag: '🇰🇲' },
    { code: 'CG', name: 'Congo', flag: '🇨🇬' },
    { code: 'CD', name: 'Congo (RDC)', flag: '🇨🇩' },
    { code: 'KR', name: 'Corea del Sur', flag: '🇰🇷' },
    { code: 'KP', name: 'Corea del Norte', flag: '🇰🇵' },
    { code: 'CI', name: 'Costa de Marfil', flag: '🇨🇮' },
    { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
    { code: 'HR', name: 'Croacia', flag: '🇭🇷' },
    { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
    { code: 'CW', name: 'Curazao', flag: '🇨🇼' },
    { code: 'DK', name: 'Dinamarca', flag: '🇩🇰' },
    { code: 'DJ', name: 'Yibuti', flag: '🇩🇯' },
    { code: 'DM', name: 'Dominica', flag: '🇩🇲' },
    { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
    { code: 'EG', name: 'Egipto', flag: '🇪🇬' },
    { code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
    { code: 'AE', name: 'Emiratos Árabes Unidos', flag: '🇦🇪' },
    { code: 'ER', name: 'Eritrea', flag: '🇪🇷' },
    { code: 'SK', name: 'Eslovaquia', flag: '🇸🇰' },
    { code: 'SI', name: 'Eslovenia', flag: '🇸🇮' },
    { code: 'ES', name: 'España', flag: '🇪🇸' },
    { code: 'US', name: 'Estados Unidos', flag: '🇺🇸' },
    { code: 'EE', name: 'Estonia', flag: '🇪🇪' },
    { code: 'ET', name: 'Etiopía', flag: '🇪🇹' },
    { code: 'PH', name: 'Filipinas', flag: '🇵🇭' },
    { code: 'FI', name: 'Finlandia', flag: '🇫🇮' },
    { code: 'FJ', name: 'Fiyi', flag: '🇫🇯' },
    { code: 'FR', name: 'Francia', flag: '🇫🇷' },
    { code: 'GA', name: 'Gabón', flag: '🇬🇦' },
    { code: 'GM', name: 'Gambia', flag: '🇬🇲' },
    { code: 'GE', name: 'Georgia', flag: '🇬🇪' },
    { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
    { code: 'GI', name: 'Gibraltar', flag: '🇬🇮' },
    { code: 'GD', name: 'Granada', flag: '🇬🇩' },
    { code: 'GR', name: 'Grecia', flag: '🇬🇷' },
    { code: 'GL', name: 'Groenlandia', flag: '🇬🇱' },
    { code: 'GP', name: 'Guadalupe', flag: '🇬🇵' },
    { code: 'GU', name: 'Guam', flag: '🇬🇺' },
    { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
    { code: 'GF', name: 'Guayana Francesa', flag: '🇬🇫' },
    { code: 'GG', name: 'Guernsey', flag: '🇬🇬' },
    { code: 'GN', name: 'Guinea', flag: '🇬🇳' },
    { code: 'GQ', name: 'Guinea Ecuatorial', flag: '🇬🇶' },
    { code: 'GW', name: 'Guinea-Bisáu', flag: '🇬🇼' },
    { code: 'GY', name: 'Guyana', flag: '🇬🇾' },
    { code: 'HT', name: 'Haití', flag: '🇭🇹' },
    { code: 'HN', name: 'Honduras', flag: '🇭🇳' },
    { code: 'HK', name: 'Hong Kong', flag: '🇭🇰' },
    { code: 'HU', name: 'Hungría', flag: '🇭🇺' },
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
    { code: 'IQ', name: 'Irak', flag: '🇮🇶' },
    { code: 'IR', name: 'Irán', flag: '🇮🇷' },
    { code: 'IE', name: 'Irlanda', flag: '🇮🇪' },
    { code: 'BV', name: 'Isla Bouvet', flag: '🇧🇻' },
    { code: 'IM', name: 'Isla de Man', flag: '🇮🇲' },
    { code: 'CX', name: 'Isla de Navidad', flag: '🇨🇽' },
    { code: 'NF', name: 'Isla Norfolk', flag: '🇳🇫' },
    { code: 'IS', name: 'Islandia', flag: '🇮🇸' },
    { code: 'KY', name: 'Islas Caimán', flag: '🇰🇾' },
    { code: 'CC', name: 'Islas Cocos', flag: '🇨🇨' },
    { code: 'CK', name: 'Islas Cook', flag: '🇨🇰' },
    { code: 'FO', name: 'Islas Feroe', flag: '🇫🇴' },
    { code: 'GS', name: 'Islas Georgias del Sur', flag: '🇬🇸' },
    { code: 'HM', name: 'Islas Heard y McDonald', flag: '🇭🇲' },
    { code: 'FK', name: 'Islas Malvinas', flag: '🇫🇰' },
    { code: 'MP', name: 'Islas Marianas del Norte', flag: '🇲🇵' },
    { code: 'MH', name: 'Islas Marshall', flag: '🇲🇭' },
    { code: 'PN', name: 'Islas Pitcairn', flag: '🇵🇳' },
    { code: 'SB', name: 'Islas Salomón', flag: '🇸🇧' },
    { code: 'TC', name: 'Islas Turcas y Caicos', flag: '🇹🇨' },
    { code: 'VI', name: 'Islas Vírgenes de EE.UU.', flag: '🇻🇮' },
    { code: 'VG', name: 'Islas Vírgenes Británicas', flag: '🇻🇬' },
    { code: 'IL', name: 'Israel', flag: '🇮🇱' },
    { code: 'IT', name: 'Italia', flag: '🇮🇹' },
    { code: 'JM', name: 'Jamaica', flag: '🇯🇲' },
    { code: 'JP', name: 'Japón', flag: '🇯🇵' },
    { code: 'JE', name: 'Jersey', flag: '🇯🇪' },
    { code: 'JO', name: 'Jordania', flag: '🇯🇴' },
    { code: 'KZ', name: 'Kazajistán', flag: '🇰🇿' },
    { code: 'KE', name: 'Kenia', flag: '🇰🇪' },
    { code: 'KG', name: 'Kirguistán', flag: '🇰🇬' },
    { code: 'KI', name: 'Kiribati', flag: '🇰🇮' },
    { code: 'KW', name: 'Kuwait', flag: '🇰🇼' },
    { code: 'LA', name: 'Laos', flag: '🇱🇦' },
    { code: 'LS', name: 'Lesoto', flag: '🇱🇸' },
    { code: 'LV', name: 'Letonia', flag: '🇱🇻' },
    { code: 'LB', name: 'Líbano', flag: '🇱🇧' },
    { code: 'LR', name: 'Liberia', flag: '🇱🇷' },
    { code: 'LY', name: 'Libia', flag: '🇱🇾' },
    { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
    { code: 'LT', name: 'Lituania', flag: '🇱🇹' },
    { code: 'LU', name: 'Luxemburgo', flag: '🇱🇺' },
    { code: 'MO', name: 'Macao', flag: '🇲🇴' },
    { code: 'MK', name: 'Macedonia del Norte', flag: '🇲🇰' },
    { code: 'MG', name: 'Madagascar', flag: '🇲🇬' },
    { code: 'MY', name: 'Malasia', flag: '🇲🇾' },
    { code: 'MW', name: 'Malaui', flag: '🇲🇼' },
    { code: 'MV', name: 'Maldivas', flag: '🇲🇻' },
    { code: 'ML', name: 'Malí', flag: '🇲🇱' },
    { code: 'MT', name: 'Malta', flag: '🇲🇹' },
    { code: 'MA', name: 'Marruecos', flag: '🇲🇦' },
    { code: 'MQ', name: 'Martinica', flag: '🇲🇶' },
    { code: 'MU', name: 'Mauricio', flag: '🇲🇺' },
    { code: 'MR', name: 'Mauritania', flag: '🇲🇷' },
    { code: 'YT', name: 'Mayotte', flag: '🇾🇹' },
    { code: 'MX', name: 'México', flag: '🇲🇽' },
    { code: 'FM', name: 'Micronesia', flag: '🇫🇲' },
    { code: 'MD', name: 'Moldavia', flag: '🇲🇩' },
    { code: 'MC', name: 'Mónaco', flag: '🇲🇨' },
    { code: 'MN', name: 'Mongolia', flag: '🇲🇳' },
    { code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
    { code: 'MS', name: 'Montserrat', flag: '🇲🇸' },
    { code: 'MZ', name: 'Mozambique', flag: '🇲🇿' },
    { code: 'MM', name: 'Myanmar', flag: '🇲🇲' },
    { code: 'NA', name: 'Namibia', flag: '🇳🇦' },
    { code: 'NR', name: 'Nauru', flag: '🇳🇷' },
    { code: 'NP', name: 'Nepal', flag: '🇳🇵' },
    { code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
    { code: 'NE', name: 'Níger', flag: '🇳🇪' },
    { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
    { code: 'NU', name: 'Niue', flag: '🇳🇺' },
    { code: 'NO', name: 'Noruega', flag: '🇳🇴' },
    { code: 'NC', name: 'Nueva Caledonia', flag: '🇳🇨' },
    { code: 'NZ', name: 'Nueva Zelanda', flag: '🇳🇿' },
    { code: 'OM', name: 'Omán', flag: '🇴🇲' },
    { code: 'NL', name: 'Países Bajos', flag: '🇳🇱' },
    { code: 'PK', name: 'Pakistán', flag: '🇵🇰' },
    { code: 'PW', name: 'Palaos', flag: '🇵🇼' },
    { code: 'PS', name: 'Palestina', flag: '🇵🇸' },
    { code: 'PA', name: 'Panamá', flag: '🇵🇦' },
    { code: 'PG', name: 'Papúa Nueva Guinea', flag: '🇵🇬' },
    { code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
    { code: 'PE', name: 'Perú', flag: '🇵🇪' },
    { code: 'PF', name: 'Polinesia Francesa', flag: '🇵🇫' },
    { code: 'PL', name: 'Polonia', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
    { code: 'PR', name: 'Puerto Rico', flag: '🇵🇷' },
    { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
    { code: 'GB', name: 'Reino Unido', flag: '🇬🇧' },
    { code: 'CF', name: 'República Centroafricana', flag: '🇨🇫' },
    { code: 'CZ', name: 'República Checa', flag: '🇨🇿' },
    { code: 'DO', name: 'República Dominicana', flag: '🇩🇴' },
    { code: 'RE', name: 'Reunión', flag: '🇷🇪' },
    { code: 'RW', name: 'Ruanda', flag: '🇷🇼' },
    { code: 'RO', name: 'Rumania', flag: '🇷🇴' },
    { code: 'RU', name: 'Rusia', flag: '🇷🇺' },
    { code: 'EH', name: 'Sahara Occidental', flag: '🇪🇭' },
    { code: 'WS', name: 'Samoa', flag: '🇼🇸' },
    { code: 'AS', name: 'Samoa Americana', flag: '🇦🇸' },
    { code: 'BL', name: 'San Bartolomé', flag: '🇧🇱' },
    { code: 'KN', name: 'San Cristóbal y Nieves', flag: '🇰🇳' },
    { code: 'SM', name: 'San Marino', flag: '🇸🇲' },
    { code: 'MF', name: 'San Martín', flag: '🇲🇫' },
    { code: 'PM', name: 'San Pedro y Miquelón', flag: '🇵🇲' },
    { code: 'VA', name: 'San Vicente y las Granadinas', flag: '🇻🇨' },
    { code: 'SH', name: 'Santa Elena', flag: '🇸🇭' },
    { code: 'LC', name: 'Santa Lucía', flag: '🇱🇨' },
    { code: 'ST', name: 'Santo Tomé y Príncipe', flag: '🇸🇹' },
    { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
    { code: 'RS', name: 'Serbia', flag: '🇷🇸' },
    { code: 'SC', name: 'Seychelles', flag: '🇸🇨' },
    { code: 'SL', name: 'Sierra Leona', flag: '🇸🇱' },
    { code: 'SG', name: 'Singapur', flag: '🇸🇬' },
    { code: 'SY', name: 'Siria', flag: '🇸🇾' },
    { code: 'SO', name: 'Somalia', flag: '🇸🇴' },
    { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
    { code: 'SZ', name: 'Suazilandia', flag: '🇸🇿' },
    { code: 'ZA', name: 'Sudáfrica', flag: '🇿🇦' },
    { code: 'SD', name: 'Sudán', flag: '🇸🇩' },
    { code: 'SS', name: 'Sudán del Sur', flag: '🇸🇸' },
    { code: 'SE', name: 'Suecia', flag: '🇸🇪' },
    { code: 'CH', name: 'Suiza', flag: '🇨🇭' },
    { code: 'SR', name: 'Surinam', flag: '🇸🇷' },
    { code: 'SJ', name: 'Svalbard y Jan Mayen', flag: '🇸🇯' },
    { code: 'TH', name: 'Tailandia', flag: '🇹🇭' },
    { code: 'TW', name: 'Taiwán', flag: '🇹🇼' },
    { code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
    { code: 'TJ', name: 'Tayikistán', flag: '🇹🇯' },
    { code: 'IO', name: 'Territorio Británico del Océano Índico', flag: '🇮🇴' },
    { code: 'TF', name: 'Territorios Franceses del Sur', flag: '🇹🇫' },
    { code: 'TL', name: 'Timor Oriental', flag: '🇹🇱' },
    { code: 'TG', name: 'Togo', flag: '🇹🇬' },
    { code: 'TK', name: 'Tokelau', flag: '🇹🇰' },
    { code: 'TO', name: 'Tonga', flag: '🇹🇴' },
    { code: 'TT', name: 'Trinidad y Tobago', flag: '🇹🇹' },
    { code: 'TN', name: 'Túnez', flag: '🇹🇳' },
    { code: 'TM', name: 'Turkmenistán', flag: '🇹🇲' },
    { code: 'TR', name: 'Turquía', flag: '🇹🇷' },
    { code: 'TV', name: 'Tuvalu', flag: '🇹🇻' },
    { code: 'UA', name: 'Ucrania', flag: '🇺🇦' },
    { code: 'UG', name: 'Uganda', flag: '🇺🇬' },
    { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
    { code: 'UZ', name: 'Uzbekistán', flag: '🇺🇿' },
    { code: 'VU', name: 'Vanuatu', flag: '🇻🇺' },
    { code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
    { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
    { code: 'WF', name: 'Wallis y Futuna', flag: '🇼🇫' },
    { code: 'YE', name: 'Yemen', flag: '🇾🇪' },
    { code: 'ZM', name: 'Zambia', flag: '🇿🇲' },
    { code: 'ZW', name: 'Zimbabue', flag: '🇿🇼' },
];

// Función para obtener un país por código
export const getCountryByCode = (code: string): Country | undefined => {
    return countries.find(country => country.code === code);
};

// Función para obtener un país por nombre
export const getCountryByName = (name: string): Country | undefined => {
    return countries.find(country => country.name === name);
}; 